/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import BaseModal from '../../common/BaseModal'
import consent from '../../../constants/drill_consent'

import './DrillLegalModal.scss'

class DrillLegalModal extends Component {
  state = {
    read: false,
    consented: false,
    validationText: '',
  }
  render() {
    const { close, type, t } = this.props
    const { consented, validationText } = this.state
    const introText =
      type === 'drill'
        ? t('drills.legalModal.introDrill')
        : t('drills.legalModal.introActivity')
    return (
      <BaseModal width={'70vw'} close={close}>
        <div id='DrillLegalModal'>
          <h2 className='text-center'>{t('drills.legalModal.title')}</h2>
          <p>{introText}</p>
          <div className='reader-box' onScroll={this._trackScroll}>
            <div
              className='consent'
              dangerouslySetInnerHTML={{ __html: consent.content }}
            />
          </div>
          <div className='checkbox-container'>
            <div
              className={`checkbox ${consented ? 'filled' : ''}`}
              onClick={this._handleCheckBox}
            >
              {consented && <i className='fa fa-check' aria-hidden='true' />}
            </div>
            <p>{t('drills.legalModal.agreementLabel')}</p>
          </div>
          {<p className='text-center text-danger'>{validationText}</p>}
          <button
            className='btn-rectangular btn-rectangular-main-positive'
            disabled={!consented}
            onClick={this._sendConsent}
          >
            {t('drills.legalModal.agree')}
          </button>
        </div>
      </BaseModal>
    )
  }

  _sendConsent = () => {
    const now = Date.now()
    const version = consent.version
    const content = consent.content
    this.props.onAgree({ consented: now, version, content })
  }

  _handleCheckBox = () => {
    if (!this.state.read) {
      this.setState({
        validationText: this.props.t('drills.legalModal.validationUnread'),
      })
    } else {
      this.setState({ validationText: '', consented: true })
    }
  }

  _trackScroll = e => {
    if (this.state.read) {
      return
    }
    const isBottom =
      e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 130

    if (isBottom) {
      this.setState({ read: true })
    }
  }
}

export default withTranslation()(DrillLegalModal)
